export default "__VITE_ASSET__CLa1GjrS__"